import React, { useContext, useEffect, useState } from 'react';

import Copy from 'assets/img/copy.svg';
import Celebration from 'assets/img/celebration.svg';

import LocaleContext from 'contexts/locale-context';
import NotificationContext from 'contexts/notification-context';

import Spacer from 'components/spacer';
import Features from 'components/features';
import Socials from 'components/socials';
import Hr from 'components/hr';

import getFeatures from 'actions/get-features';
import copyToClipboard from 'helpers/copy-to-clipboard';


const onCopy = (link, setNotification, jsTranslations) => e => {
  e.preventDefault();
  e.stopPropagation();

  copyToClipboard(link);
  setNotification({
    message: jsTranslations.copied,
    type: 'success',
    autoCancel: true
  });
}


const Uploaded = ({ link: downloadLink, transferId, password }) => {
  const [features, setFeatures] = useState([]);

  const { translations } = useContext(LocaleContext);
  const { setNotification } = useContext(NotificationContext);

  useEffect(() => {
    const _getFeatures = async () => {
      try {
        setFeatures(await getFeatures())
      } catch(e) {}
    }

    _getFeatures();
  }, []);

  const pageTranslations = translations.index;
  const jsTranslations = translations.js;

  return (
    <div className='home__uploaded__container'>
      <h2>{pageTranslations.all_done}</h2>
      <img src={Celebration} />

      <Spacer size='l'/>

      <h2>{pageTranslations.download_link}</h2>
      {downloadLink &&
        <div className='home__uploaded__download-link'>
          <h3>
            {downloadLink}
          </h3>
          {' '}
          {' '}
          <img
            onClick={onCopy(downloadLink, setNotification, jsTranslations)}
            className='clickable' alt='copy icon'
            src={Copy}
          />
        </div>
      }

      <Spacer size='5xl'/>

      <Hr />

      <Spacer size='m'/>

      <h2>{pageTranslations.share_your_link}</h2>
      <Socials downloadLink={downloadLink} transferId={transferId} password={password}/>

      <Spacer size='xl'/>

      <Features
        features={features}
        transferId={transferId}
        password={password}
      />
    </div>
  );
};

export default Uploaded;